import { c as _c } from "react/compiler-runtime";
import React from "react";
import clsx from "clsx";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import MediaDisplay from "@/components/drops/view/item/content/media/MediaDisplay";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { ImageScale } from "@/helpers/image.helpers";
import WaveDropPartContentMediaImage from "./WaveDropPartContentMediaImage";
function isRenderableMedia(mimeType: string, url: string): boolean {
  return mimeType.includes("image") || mimeType.includes("video") || mimeType.includes("audio") || mimeType === "model/gltf-binary" || mimeType === "model/gltf+json" || mimeType === "text/html" || url.endsWith(".glb") || url.endsWith(".gltf");
}
interface WaveDropPartContentMediasProps {
  readonly activePart: ApiDropPart;
  readonly disableMediaInteraction?: boolean | undefined;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly imageScale?: ImageScale | undefined;
  readonly mediaContainerHeightClassName?: string | undefined;
  readonly fullWidthMedia?: boolean | undefined;
}
const WaveDropPartContentMedias: React.FC<WaveDropPartContentMediasProps> = t0 => {
  const $ = _c(21);
  const {
    activePart,
    disableMediaInteraction: t1,
    isCompetitionDrop: t2,
    imageScale: t3,
    mediaContainerHeightClassName: t4,
    fullWidthMedia: t5
  } = t0;
  const disableMediaInteraction = t1 === undefined ? false : t1;
  const isCompetitionDrop = t2 === undefined ? false : t2;
  const imageScale = t3 === undefined ? ImageScale.AUTOx450 : t3;
  const mediaContainerHeightClassName = t4 === undefined ? "tw-h-64" : t4;
  const fullWidthMedia = t5 === undefined ? false : t5;
  if (!activePart.media.length) {
    return null;
  }
  const hasContentBeforeMedia = Boolean(activePart.content?.trim()) || Boolean(activePart.quoted_drop?.drop_id);
  let topSpacingClassName = "tw-mt-1";
  if (hasContentBeforeMedia) {
    topSpacingClassName = "tw-mt-4";
  } else {
    if (fullWidthMedia) {
      topSpacingClassName = "tw-mt-0";
    }
  }
  let t6;
  if ($[0] !== topSpacingClassName) {
    t6 = clsx(topSpacingClassName, "tw-space-y-3");
    $[0] = topSpacingClassName;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const mediaStackClassName = t6;
  let t7;
  if ($[2] !== fullWidthMedia || $[3] !== mediaContainerHeightClassName) {
    t7 = t8 => {
      const {
        useIntrinsicHeightMedia,
        useCompactLink
      } = t8;
      if (useCompactLink) {
        return "tw-w-full";
      }
      if (useIntrinsicHeightMedia) {
        return "tw-flex tw-w-full tw-min-w-[min(200px,100%)] tw-max-h-64 tw-items-center tw-justify-center";
      }
      return clsx("tw-flex tw-min-w-[min(200px,100%)] tw-items-center tw-justify-center", mediaContainerHeightClassName, fullWidthMedia && "tw-w-full");
    };
    $[2] = fullWidthMedia;
    $[3] = mediaContainerHeightClassName;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const getMediaContainerClassName = t7;
  let t8;
  if ($[5] !== activePart.media || $[6] !== disableMediaInteraction || $[7] !== fullWidthMedia || $[8] !== getMediaContainerClassName || $[9] !== imageScale || $[10] !== isCompetitionDrop) {
    let t9;
    if ($[12] !== disableMediaInteraction || $[13] !== fullWidthMedia || $[14] !== getMediaContainerClassName || $[15] !== imageScale || $[16] !== isCompetitionDrop) {
      t9 = (media, i) => {
        const useNaturalHeightImage = fullWidthMedia && media.mime_type.includes("image");
        const useImageIntrinsicHeight = !fullWidthMedia && media.mime_type.includes("image");
        const useVideoIntrinsicHeight = media.mime_type.includes("video");
        const useCompactLink_0 = !isRenderableMedia(media.mime_type, media.url);
        const mediaContainerClassName = getMediaContainerClassName({
          useIntrinsicHeightMedia: useNaturalHeightImage || useImageIntrinsicHeight || useVideoIntrinsicHeight,
          useCompactLink: useCompactLink_0
        });
        let mediaContent;
        if (disableMediaInteraction) {
          mediaContent = <MediaDisplay media_mime_type={media.mime_type} media_url={media.url} disableMediaInteraction={disableMediaInteraction} imageScale={imageScale} />;
        } else {
          if (useNaturalHeightImage || useImageIntrinsicHeight) {
            mediaContent = <WaveDropPartContentMediaImage src={media.url} imageScale={imageScale} imageObjectPosition={useImageIntrinsicHeight ? "left top" : "center"} />;
          } else {
            mediaContent = <DropListItemContentMedia media_mime_type={media.mime_type} media_url={media.url} isCompetitionDrop={isCompetitionDrop} imageScale={imageScale} />;
          }
        }
        return <div key={`part-${i}-media-${media.url}`}><div className={mediaContainerClassName}>{mediaContent}</div></div>;
      };
      $[12] = disableMediaInteraction;
      $[13] = fullWidthMedia;
      $[14] = getMediaContainerClassName;
      $[15] = imageScale;
      $[16] = isCompetitionDrop;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    t8 = activePart.media.map(t9);
    $[5] = activePart.media;
    $[6] = disableMediaInteraction;
    $[7] = fullWidthMedia;
    $[8] = getMediaContainerClassName;
    $[9] = imageScale;
    $[10] = isCompetitionDrop;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[18] !== mediaStackClassName || $[19] !== t8) {
    t9 = <div className={mediaStackClassName}>{t8}</div>;
    $[18] = mediaStackClassName;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
export default WaveDropPartContentMedias;